// extracted by mini-css-extract-plugin
module.exports = {"virtual-visit-form":"virtual-visit-form___3aOqJ","user-row":"user-row___xglYD","farm-row":"farm-row___FfNdm"};